module.exports = __webpack_public_path__ + "img/image_why03.77872194.png";